@if (loaded) {
    <div class="row">
        <div class="col-12 col-sm-6">
            <label class="form-label">{{ 'permissions' | translate }}</label>

            @for (permission of permissions; track permission; let i = $index) {
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="pm-permission-{{i}}"
                           [(ngModel)]="permissionCheckboxes[i]"
                           (ngModelChange)="onPermissionChange()"
                           [disabled]="isDisabled">
                    <label class="form-check-label" for="pm-permission-{{i}}">
                        {{ permission['label' + crtLang.toUpperCase()] }}
                    </label>
                </div>
            }
        </div>
    </div>
}
